import React from "react";
import callUs from "utils/call-us";
import { Link as GatsbyLink } from "gatsby";

const isExternal = (url) => {
    // Telephone Number Regex, this covers xxx-xxx-xxxx (and a bunch of other similar numbers)
    const telNumRegex = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im;
    const externalSiteRegex = /http/;

    switch (true) {
    case telNumRegex.test(url):
        // This transform a simple number, 000-000-0000 to tel:000-000-0000
        return { href: callUs(url) };    
    case externalSiteRegex.test(url):
        // This returns external pages, e.g https://sealskincovers.com/help
        return { href: url };
    case url === undefined:
        return { href: "#" };
    default:
        return undefined;
    }
};

const liveChatTrigger = (event, url) => {
    const newUrl = url.toLowerCase();
    if (newUrl === "#chat" || newUrl === "chat") {
        event.preventDefault();
        window?.LiveChatWidget?.call("maximize");
    }
};

// eslint-disable-next-line id-length
const Link = ({ children, to, activeClassName, partiallyActive, onClick, ...other }) => (isExternal(to) ? (
    <a className={activeClassName} {...other} {...isExternal(to)}>
        {children}
    </a>
) : (
    <GatsbyLink
        to={to}
        activeClassName={activeClassName}
        partiallyActive={partiallyActive}
        onClick={(event) => {
            liveChatTrigger(event, to);
            if (onClick) onClick(event);
        }}
        {...other}
        state={{ ...other?.state, prevUrl: typeof window !== "undefined" ? window.location.href : "" }}
    >
        {children}
    </GatsbyLink>
));
export default Link;
